import { ImageUploadClient } from '@spotify/confidence-backstage-image-upload';

import { ConfidenceUserApi } from './UserApi';
import {
  requestSignedUpload,
  uploadFileToSignedUri,
} from './imageUpload.helpers';

/**
 * Implementation of the ImageUpload API that uses the Confidence API to
 * store images.
 *
 * It depends on the Confidence User API to get the access token to make
 * the request to the Confidence API.
 */
export class ConfidenceImageUploadClient implements ImageUploadClient {
  private readonly userApi: ConfidenceUserApi;

  constructor(userApi: ConfidenceUserApi) {
    this.userApi = userApi;
  }

  async upload(file: File): Promise<string> {
    const accessToken = await this.userApi.getAccessToken();

    const { signedUri, imageUri } = await requestSignedUpload(accessToken);

    await uploadFileToSignedUri(signedUri, file);
    return imageUri;
  }
}
